<template>
    <div class="flex items-start p-4 mt-8 bg-primary-50 rounded" :class="$attrs.class">
        <div>
            <template v-if="icon">
                <span
                    class="flex items-center justify-center"
                     v-html="icon"
                ></span>
            </template>
        </div>
        <div>
        <h4 class="font-medium text-neutral-900 mb-1">{{ title }}</h4>
        <p class="text-sm text-neutral-900 mb-3">{{ subtitle }}</p>
        <div class="flex items-center">
            <div
                class="mr-3 flex items-center justify-center">
                <template v-if="avatar">
                    <img
                        :src="avatar"
                        :alt="contactName"
                        :style="avatarImgStyle"
                    /> 
                </template>
                <template v-if="contactName && !avatar">
                    <div
                        :style="avatarImgStyle"
                        class="bg-neutral-200 flex items-center justify-center text-neutral-500 text-xl"
                    >
                        {{ contactName.charAt(0).toUpperCase() }}
                    </div>
                </template>
            </div>
            <div>
                <div class="font-medium text-sm text-neutral-900" v-html="contactInfo"></div>
                <div v-if="contactName" class="text-xs text-neutral-900">{{ contactName }}</div>
            </div>
        </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    icon: { type: String, required: false, default: '' },
    title: { type: String, required: true },
    subtitle: { type: String, required: false, default: '' },
    avatar: { type: String, required: false, default: '' },
    contactInfo: { type: String, required: false, default: '' },
    contactName: { type: String, required: false, default: '' }
})

const avatarImgStyle = 'width: 40px !important; height: 40px !important; object-fit: cover !important; border-radius: 50% !important; display: block !important; min-width: 40px !important; min-height: 40px !important; max-width: 40px !important; max-height: 40px !important;'
</script>